// French (fr) — EU MDR submission language.
// Covers the visitor-facing eIFU portal strings only; the admin console is not
// localized. Missing keys fall back to English (see src/i18n.js).
const fr = {
  'show all manuals': 'afficher tous les manuels',
  eifuPortalIntro:
    'Consultez et téléchargez les instructions d’utilisation électroniques (eIFU) des logiciels de dispositifs médicaux RAY.',
  'Checking the latest documents.': 'Vérification des documents les plus récents.',
  'There are no manuals to display.': 'Aucun manuel à afficher.',
  Manuals: 'Manuels',
  'Product Name': 'Nom du produit',
  Language: 'Langue',
  'Document Name': 'Nom du document',
  Product: 'Produit',
  Revision: 'Révision',
  Document: 'Document',
  Published: 'Publié',
  Country: 'Pays',
  'All countries': 'Tous les pays',
  Search: 'Rechercher',
  'No results': 'Aucun résultat',
  'appManuals.downloadHelpText':
    'Les fichiers téléchargés peuvent être consultés dans un navigateur internet ou avec un logiciel de lecture de PDF.',
  'appManuals.systemRequirements':
    'Configuration requise : processeur Intel® Core™ i3 ou supérieur, 4 Go de mémoire ou plus, 100 Mo ou plus d’espace de stockage disponible pour l’enregistrement du PDF.',
  'criticalNotice.badge': 'Avis important',
  'criticalNotice.close': 'Fermer',
};

export default fr;
